import { CheckOutlined } from '@ant-design/icons';
import { Table as TableAntd } from 'antd';
import styled from 'styled-components';

export const CheckOutlinedStyle = styled(CheckOutlined)`
  svg {
    color: red;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-right: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 12px;
    height: 44px;
    background: #f5f5f6;
    border: 1px solid #dfdfdf;
  }

  table tr > td {
    padding: 0px 16px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    height: 56px;
  }
`;

export const DownloadLink = styled.a`
  font-weight: bold;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    opacity: 0.5;
  }
`;
